import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface SubblockHeadingProps {
  icon: ReactNode;
  title: string;
}

/**
 * Small uppercase label with a leading icon — the "Providers" / "Coding" subblock
 * heading inside a claim's bill-type card (portal `ClaimBillTypeCard`) or claim card
 * (backoffice `ClaimsList`, via `CodingSection`).
 */
export default function SubblockHeading({ icon, title }: SubblockHeadingProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      {icon}
      <Typography
        sx={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'text.secondary' }}
      >
        {title}
      </Typography>
    </Box>
  );
}
